<template>
  <header class="ga-header mdl-layout__header">
    <div class="mdl-layout__header-row">
      <!-- Title -->
      <span v-if="logged" class="ga-title mdl-layout-title mdl-typography--font-light">{{user.firstName}}</span>
      <span v-else class="ga-title mdl-layout-title mdl-typography--font-light">{{'general.application.title' | label}}</span>
      <div class="ga-header-spacer mdl-layout-spacer" ></div>
      <div class="ga-search-box mdl-textfield--align-right " >
        <mdl-select name='lang' :value.sync="lang" options="LANG"></mdl-select>
      </div>

      <!-- Tabs -->
      <div class="ga-navigation-container">
        <nav class="ga-navigation mdl-navigation">
          <a v-for="item in menu"
             v-link="{
              path: item.path,
              activeClass: 'is-active'
            }" class="mdl-navigation__link mdl-typography--text-uppercase">{{item.label | label}}</a>
          <a v-if="logged" class="mdl-navigation__link mdl-typography--text-uppercase" v-on:click="$dispatch('logout')">
            {{ 'general.application.logout' | label }}
          </a>
        </nav>
      </div>
    </div>
  </header>
</template>
<script>
var transform = function (elem) {
  return {label: elem.label, path: elem.value}
}
var api = require('api')
var getters = require('common/store/getters')
var actions = require('common/store/actions')
module.exports = {
  ready: function () {
  },
  components: {
    mdlSelect: require('c/components/Select')
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  watch: {
    // lang: function (val) {
    //   this.changeLanguage(val)
    // },
    logged: function (val) {
      var self = this
      if (val) {
        api.Menu.get().then(function (resp) {
          self.menu = resp.data.map(transform)
        })
      }
    }
  },
  data: function () {
    return {
      menu: []
    }
  },
  computed: {
    lang: {
      get: function () {
        return this.language
      },
      set: function (val) {
        this.changeLanguage(val).then(function () {
          var split = location.href.split('?lang=')
          location.href = split[0] + '?lang=' + val
        })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Heading.vue?be2c997c